<template>
  <a :href="to" @click="navigate">
      <v-slot></v-slot>
  </a>
</template>

<script>
export default {
    name: 'Link',
    props: {
        to: {
            type: String,
            required: true
        }
    },
    methods: {
        navigate(evt) {
            evt.preventDefault();
            this.$route.push(this.to)
            this.$emit('navigate')
        }
    },
    created() {
        console.log('basladi link');
    }
}
</script>

<style>

</style>